var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-download",
    d: "M17.339,4.593,13.407.661A2.25,2.25,0,0,0,11.819,0H2.25A2.257,2.257,0,0,0,0,2.254v19.5A2.25,2.25,0,0,0,2.25,24h13.5A2.25,2.25,0,0,0,18,21.75V6.186a2.261,2.261,0,0,0-.661-1.593ZM12,1.528a.737.737,0,0,1,.347.2L16.28,5.656a.737.737,0,0,1,.2.347H12ZM16.5,21.75a.752.752,0,0,1-.75.75H2.25a.752.752,0,0,1-.75-.75V2.254A.756.756,0,0,1,2.25,1.5H10.5V6.378A1.12,1.12,0,0,0,11.626,7.5H16.5ZM9.75,10.125a.375.375,0,0,0-.375-.375h-.75a.375.375,0,0,0-.375.375v4.126H5.782a1.263,1.263,0,0,0-1.172.784,1.33,1.33,0,0,0,.255,1.444l3.193,3.365a1.292,1.292,0,0,0,1.883,0l3.193-3.363a1.333,1.333,0,0,0,.255-1.445,1.263,1.263,0,0,0-1.172-.784H9.75Zm2.008,5.626L9,18.657,6.242,15.751Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.e55bfcf3c06a841232a6d962af417d8d.svg";
export { ForwardRef as ReactComponent };